import { createClient } from '@supabase/supabase-js';

const supabaseURL: string = process.env.REACT_APP_SUPABASE_URL as string;
const supabaseKey: string = process.env.REACT_APP_SUPABASE_KEY as string;

export const client = createClient(supabaseURL, supabaseKey);

export function checkError(statusCode: number) {
  switch (statusCode) {
    case 400:
      throw new Error('Bad Request');
    case 401:
      throw new Error('Unauthorized');
    case 403:
      throw new Error('Forbidden Gateway');
    case 404:
      throw new Error('Not Found');
    case 408:
      throw new Error('Request Timeout');
    case 500:
      throw new Error('Internal Server Error');
    case 502:
      throw new Error('Bad Gateway');
    case 504:
      throw new Error('Gateway Timeout');
    default:
      throw new Error('Unknown Error');
  }
}
